import { React, useState, useContext, useEffect } from "react";
import TopBar from "../../compenent/TopBar";
import CloseBtn from '../../assest/CloseBtn.svg'
import { AddCardSchema } from "../../Validation/AddCardVal";
import { useFormik } from "formik";
import LoadingBtn from "../../compenent/LoadingBtn";
import axios from "axios";
import { Sdata } from "../../assest/data/Sdata";
import Masseege from "../../compenent/masseege"
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Usercontext } from "../../context/Usercontexte";
import Dexie from 'dexie';
import { useTranslation } from "react-i18next";

function AddCardManully({setIsCardChange , IsCardChange }) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewUrl2, setPreviewUrl2] = useState(null);
  const [frontImage, setFrontImage] = useState(null);
  const [backImage ,setBackImage] = useState(null);
  const [msg, setMsg] = useState({ text: "", color: "" });
  const [img, setimg] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedCard , setSelectedCard] = useState()
  const {setCard } = useContext(Usercontext)
  const {t , i18n} = useTranslation()
 var isArabic = i18n.language.startsWith('ar');
  const Navto = useNavigate();
 

const {id} = useParams()
 
  const { setValues, values, handleBlur, errors, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        storename: "",
        cardnum: "",
        notes:""
      },
      validationSchema: AddCardSchema,
      onSubmit,
    });
     
const Database = new Dexie('Database');
Database.version(1).stores({
  receipts: 'created_at',
  users: 'id', // Assuming 'id' is the primary key for users
  cards: 'id',
});
 

useEffect(()=>{
const getData = Sdata.find((item)=> item.id ==  id )
  setSelectedCard(getData)

},[] )

const addCardToLocalDB = async (newCard) => {
  try {
    await Database.transaction('rw', Database.cards, async () => {
      await Database.cards.put(newCard);
      setCard((prevCards) => 
     [newCard, ...prevCards] 
   )
    });     
  } catch (error) {
  }
};


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
     
      const fileSizeInMB = selectedFile.size / (1024 * 1024); // Convert bytes to megabytes
  
      // Check if the file size is less than 2MB
      if (fileSizeInMB >= 5) {
        setMsg({
          text: t('Msg.FileSizeExceed'),
          color: "bg-[#FF1203F5] text-[0.9rem]",
        });
         return;
      }  
    setFrontImage(selectedFile);
    if(!selectedFile){
      return
     }
    // Create a temporary URL for the selected image
    const imageUrl = URL.createObjectURL(selectedFile);
    setPreviewUrl(imageUrl);
  };

  const handleFileChange2 = (e) => {
    const selectedFile = e.target.files[0];
    const fileSizeInMB = selectedFile.size / (1024 * 1024); // Convert bytes to megabytes

    if (fileSizeInMB >= 5) {
      setMsg({
        text: t('Msg.FileSizeExceed'),
        color: "bg-[#FF1203F5] text-[0.9rem]",
      });
       return;
    }  
    setBackImage(selectedFile);
 if(!selectedFile){
  return
 }
    const imageUrl = URL.createObjectURL(selectedFile);
    setPreviewUrl2(imageUrl);
  };

  async function onSubmit() {
    setIsLoading(true)
    const token = Cookies.get("access_token");
    const headers = {
      'Accept': '*/*',
      'Connection': 'keep-alive',
      Authorization: token ,
    };

    const formData = new FormData();
    if(frontImage != null ){
formData.append('front_image', frontImage);
    }
    if(backImage !=  null ){
      formData.append('back_image', backImage);
    }

    formData.append('code', values.cardnum);
    formData.append('notes', values.notes);
    formData.append('store_name', values.storename);
    
   

    if(id && !selectedCard){
      try {
      const response = await axios.put( `https://django-cloudrun-5cc2zmgpqq-lz.a.run.app/api/clients/fidelity_cards${id}` ,   formData  , { headers });
 setIsLoading(false)
           setMsg({
                text: "Card updated successfully",
                color: "bg-green-400 text-[0.9rem]",
              });
              setTimeout(() => {
                 Navto('/Cards')
              }, 2000);


    } catch (error) {
    setIsLoading(false)

      setMsg({
                text: t('Msg.UpdateCardError'),
                color: "bg-[#FF1203F5] text-[0.9rem]",
              });
    }
  }
  else{
    try {
      const response = await axios.post('https://django-cloudrun-5cc2zmgpqq-lz.a.run.app/api/clients/fidelity_cards', formData, { headers });
      await addCardToLocalDB(response?.data);
    
      console.log('Response:', response);
    
      if (response.status === 201) {
        console.log('added');
        setMsg({
          text: t('Msg.CardAddedSuccess'),
          color: "bg-green-400 text-[0.9rem]",
        });
    
        setTimeout(() => {
          Navto('/Cards');
        }, 2000);
      } else {
        console.log('Unexpected status code:', response.status);
      }
    } catch (error) {
      console.log('Error:', error);
    
      setIsLoading(false);
    
      setMsg({
        text: t('Msg.AddCardError'),
        color: "bg-[#FF1203F5] text-[0.9rem]",
      });
    }}
    

    }
    

   // Geting card info from the server 
  useEffect(() => {
    const token = Cookies.get("access_token");
    if(id && !selectedCard){
    axios.get( `/api/clients/fidelity_cards/${id}` ,{
      headers: {
        Authorization: token,
      },
    } ).then((response)=>{
      const {data} = response;
      setValues({
        storename: data?.store_name ,
        cardnum:  data?.code,
        notes: data?.notes
      })
      setFrontImage(data?.front_image )
      setPreviewUrl(data?.front_image )
      setBackImage(data?.back_image )
      setPreviewUrl2(data?.back_image  )
    }  ).catch((error)=>{
      console.error()
    } )       
  }
  }, []);






// Geting card already exsit
useEffect(()=>{
  if (selectedCard) {
    // Fetch the image as a blob
    fetch(selectedCard?.img)
  .then((response) => response.blob())
  .then((blob) => {
    // Create a File object from the blob
    const fileName = 'nikes1.jpg';
    const file = new File([blob], fileName, { type: blob.type });
    // Set the File object in the component's state
  console.log(img)
  setPreviewUrl(URL.createObjectURL(file))
setPreviewUrl2(URL.createObjectURL(file))
setBackImage(file)
setFrontImage(file)
 });
      setValues({
        storename:selectedCard?.text
      })
    }
},[selectedCard ] )





 

  return (
    <div className=" px-[1.2rem] pt-[1.8rem] flex flex-col pb-12 ">
      <TopBar text={id ? t('card.EditC') : t('card.addC')} />

      <form className="  py-12" onSubmit={handleSubmit}>
        <div className=  {` w-full flex ${isArabic ?'  flex-row-reverse ' :'  flex-row'} gap-2 justify-center items-center `} >
         
        <label  className="    h-[7rem] w-[9rem]  border-solid border-[1px] relative overflow-hidden rounded-md items-center justify-center gap-2 flex flex-col " >
        <input
       
          type="file"
          accept="image/*" // Specify accepted file types if needed
          onChange={handleFileChange}
          multiple={false}
          style={{ display: 'none' }}
        />
   
 { previewUrl &&  <button type="button" onClick={(e) => { setFrontImage(''); setPreviewUrl(''); e.preventDefault(); }}>
 
 <img  className=" absolute top-2 right-2 z-20" src={CloseBtn} alt="" />
</button>}
          {previewUrl && frontImage && <img src={ previewUrl} alt="Selected"  className=" w-full h-full   object-cover absolute top-0 right-0"  />}
        
        {!previewUrl && !frontImage  &&  <span className=" h-[7rem] w-[9rem]  border-solid border-[1px] rounded-md items-center justify-center gap-2 flex flex-col  ">
        <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M14.6936 1.91362H12.4833L11.3965 0.283854C11.3383 0.196586 11.2595 0.125026 11.167 0.0755128C11.0745 0.0259999 10.9712 6.29939e-05 10.8663 0H5.76332C5.65842 6.29939e-05 5.55514 0.0259999 5.46265 0.0755128C5.37017 0.125026 5.29132 0.196586 5.23309 0.283854L4.14552 1.91362H1.93608C1.42856 1.91362 0.941821 2.11523 0.582948 2.47411C0.224074 2.83298 0.0224609 3.31972 0.0224609 3.82724V12.7575C0.0224609 13.265 0.224074 13.7517 0.582948 14.1106C0.941821 14.4695 1.42856 14.6711 1.93608 14.6711H14.6936C15.2011 14.6711 15.6878 14.4695 16.0467 14.1106C16.4056 13.7517 16.6072 13.265 16.6072 12.7575V3.82724C16.6072 3.31972 16.4056 2.83298 16.0467 2.47411C15.6878 2.11523 15.2011 1.91362 14.6936 1.91362ZM15.3314 12.7575C15.3314 12.9266 15.2642 13.0889 15.1446 13.2085C15.025 13.3281 14.8627 13.3953 14.6936 13.3953H1.93608C1.76691 13.3953 1.60466 13.3281 1.48504 13.2085C1.36541 13.0889 1.29821 12.9266 1.29821 12.7575V3.82724C1.29821 3.65807 1.36541 3.49582 1.48504 3.3762C1.60466 3.25657 1.76691 3.18937 1.93608 3.18937H4.48758C4.59262 3.18944 4.69605 3.16356 4.78869 3.11404C4.88133 3.06453 4.96031 2.9929 5.01861 2.90551L6.10459 1.27575H10.5243L11.611 2.90551C11.6693 2.9929 11.7483 3.06453 11.8409 3.11404C11.9336 3.16356 12.037 3.18944 12.1421 3.18937H14.6936C14.8627 3.18937 15.025 3.25657 15.1446 3.3762C15.2642 3.49582 15.3314 3.65807 15.3314 3.82724V12.7575ZM8.31482 4.46512C7.62094 4.46512 6.94265 4.67087 6.36571 5.05637C5.78877 5.44187 5.3391 5.98979 5.07357 6.63085C4.80803 7.27191 4.73856 7.97731 4.87393 8.65786C5.00929 9.3384 5.34343 9.96352 5.83407 10.4542C6.32472 10.9448 6.94984 11.2789 7.63038 11.4143C8.31093 11.5497 9.01633 11.4802 9.65739 11.2147C10.2984 10.9491 10.8464 10.4995 11.2319 9.92253C11.6174 9.34559 11.8231 8.6673 11.8231 7.97342C11.8221 7.04328 11.4521 6.15155 10.7944 5.49384C10.1367 4.83613 9.24496 4.46617 8.31482 4.46512ZM8.31482 10.206C7.87326 10.206 7.44162 10.075 7.07448 9.82973C6.70733 9.58441 6.42118 9.23573 6.2522 8.82778C6.08323 8.41984 6.03902 7.97094 6.12516 7.53787C6.2113 7.1048 6.42393 6.70699 6.73616 6.39476C7.04839 6.08254 7.44619 5.8699 7.87927 5.78376C8.31234 5.69762 8.76124 5.74183 9.16918 5.91081C9.57713 6.07978 9.92581 6.36594 10.1711 6.73308C10.4164 7.10022 10.5474 7.53186 10.5474 7.97342C10.5474 8.56553 10.3122 9.13339 9.89348 9.55208C9.47479 9.97076 8.90693 10.206 8.31482 10.206Z"
                fill="#06C671"
              />
            </svg> 
            <h1 className=" text-sm"> {t('card.Front')}</h1>
          </span>}
         
      </label>
      <label  className="  h-[7rem] w-[9rem]  border-solid border-[1px] relative overflow-hidden rounded-md items-center justify-center gap-2 flex flex-col " >
        <input
        className=""
          type="file"
          accept="image/*" // Specify accepted file types if needed
          onChange={handleFileChange2}
          multiple={false}
          style={{ display: 'none' }}
          />
        
        { previewUrl2  &&  <button type="button" onClick={(e) => { setBackImage(null); setPreviewUrl2(''); e.preventDefault(); }}>
 
<img  className=" absolute top-2 right-2 z-20"  src={CloseBtn} alt="" />
</button>}
          {previewUrl2 && backImage && <img className=" w-full h-full  object-cover absolute top-0 right-0" src={previewUrl2} alt="Selected"  />}
        {!previewUrl2 && !backImage &&  <span className=" h-[7rem] w-[9rem]  border-solid border-[1px] rounded-md items-center justify-center gap-2 flex flex-col  ">
        <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M14.6936 1.91362H12.4833L11.3965 0.283854C11.3383 0.196586 11.2595 0.125026 11.167 0.0755128C11.0745 0.0259999 10.9712 6.29939e-05 10.8663 0H5.76332C5.65842 6.29939e-05 5.55514 0.0259999 5.46265 0.0755128C5.37017 0.125026 5.29132 0.196586 5.23309 0.283854L4.14552 1.91362H1.93608C1.42856 1.91362 0.941821 2.11523 0.582948 2.47411C0.224074 2.83298 0.0224609 3.31972 0.0224609 3.82724V12.7575C0.0224609 13.265 0.224074 13.7517 0.582948 14.1106C0.941821 14.4695 1.42856 14.6711 1.93608 14.6711H14.6936C15.2011 14.6711 15.6878 14.4695 16.0467 14.1106C16.4056 13.7517 16.6072 13.265 16.6072 12.7575V3.82724C16.6072 3.31972 16.4056 2.83298 16.0467 2.47411C15.6878 2.11523 15.2011 1.91362 14.6936 1.91362ZM15.3314 12.7575C15.3314 12.9266 15.2642 13.0889 15.1446 13.2085C15.025 13.3281 14.8627 13.3953 14.6936 13.3953H1.93608C1.76691 13.3953 1.60466 13.3281 1.48504 13.2085C1.36541 13.0889 1.29821 12.9266 1.29821 12.7575V3.82724C1.29821 3.65807 1.36541 3.49582 1.48504 3.3762C1.60466 3.25657 1.76691 3.18937 1.93608 3.18937H4.48758C4.59262 3.18944 4.69605 3.16356 4.78869 3.11404C4.88133 3.06453 4.96031 2.9929 5.01861 2.90551L6.10459 1.27575H10.5243L11.611 2.90551C11.6693 2.9929 11.7483 3.06453 11.8409 3.11404C11.9336 3.16356 12.037 3.18944 12.1421 3.18937H14.6936C14.8627 3.18937 15.025 3.25657 15.1446 3.3762C15.2642 3.49582 15.3314 3.65807 15.3314 3.82724V12.7575ZM8.31482 4.46512C7.62094 4.46512 6.94265 4.67087 6.36571 5.05637C5.78877 5.44187 5.3391 5.98979 5.07357 6.63085C4.80803 7.27191 4.73856 7.97731 4.87393 8.65786C5.00929 9.3384 5.34343 9.96352 5.83407 10.4542C6.32472 10.9448 6.94984 11.2789 7.63038 11.4143C8.31093 11.5497 9.01633 11.4802 9.65739 11.2147C10.2984 10.9491 10.8464 10.4995 11.2319 9.92253C11.6174 9.34559 11.8231 8.6673 11.8231 7.97342C11.8221 7.04328 11.4521 6.15155 10.7944 5.49384C10.1367 4.83613 9.24496 4.46617 8.31482 4.46512ZM8.31482 10.206C7.87326 10.206 7.44162 10.075 7.07448 9.82973C6.70733 9.58441 6.42118 9.23573 6.2522 8.82778C6.08323 8.41984 6.03902 7.97094 6.12516 7.53787C6.2113 7.1048 6.42393 6.70699 6.73616 6.39476C7.04839 6.08254 7.44619 5.8699 7.87927 5.78376C8.31234 5.69762 8.76124 5.74183 9.16918 5.91081C9.57713 6.07978 9.92581 6.36594 10.1711 6.73308C10.4164 7.10022 10.5474 7.53186 10.5474 7.97342C10.5474 8.56553 10.3122 9.13339 9.89348 9.55208C9.47479 9.97076 8.90693 10.206 8.31482 10.206Z"
                fill="#06C671"
              />
            </svg> 
            <h1 className=" text-sm">{t('card.Back')}</h1>
          </span>}
         
      </label>
        </div>

        <div className=" flex flex-col  ">
          <h1 className=" font-medium  pb-2   pt-[1.5rem] text-[.9rem] ">
           {t('card.Sname')} 
          </h1>
          <input
            placeholder={t('card.SnamePlaceh')} 
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.storename}
            className={`  ${isArabic ?'  text-right ' :'  text-left'}  ${
              errors.storename && touched.storename
                ? " border-[#fc8181] text-red-500  border-[2px]"
                : ""
            } text-sec w-full h-[4rem]  bg-transparent    px-[1rem]   text-sm  border-solid border-[1px] rounded-[0.32rem]`}
            type="text"
            name=""
            id="storename"
          />
          {errors.storename && touched.storename && (
            <p className="   pt-1 px-1 text-xs text-red-400">
              {" "}
              {errors.storename}{" "}
            </p>
          )}
        </div>
        <div className=" flex flex-col  ">
          <h1 className="pb-2  pt-[1.5rem] text-[.9rem] font-medium ">
         {t('card.Cnumber')} 
          </h1>
          <input
            placeholder=  {t('card.CnumberPlach')} 
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.cardnum}
            className={`  ${isArabic ?'  text-right ' :'  text-left'}  ${
              errors.cardnum && touched.cardnum
                ? " border-[#fc8181] text-red-500  border-[2px]"
                : ""
            } text-sec w-full h-[4rem] bg-transparent   px-[1rem]   text-sm  border-solid border-[1px] rounded-[0.32rem]`}
            type="text"
            id="cardnum"
          />
          {errors.cardnum && touched.cardnum && (
            <p className=" pt-1 px-1 text-xs text-red-400">
              {" "}
              {errors.cardnum}{" "}
            </p>
          )}
        </div>

        <div className=" flex flex-col   ">
          <h1 className="pb-2   pt-[1.5rem] text-[.9rem] font-medium  ">
            {t('card.Anotes')} 
          </h1>
          <input
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.notes}
            placeholder={t('card.Notes')}
            className={`   ${isArabic ?'  text-right ' :'  text-left'} bg-transparent   text-sec w-full h-[4rem]   px-[1rem]   text-sm  border-solid border-[1px] rounded-[0.32rem]`}
            id="notes"
          />
          {errors.email && touched.email && (
            <p className=" pt-1 px-1 text-xs text-red-400"> {errors.email} </p>
          )}
        </div>

        <div className=" w-full pt-10 flex flex-row gap-2 ">
          <button onClick={(e)=> {e.preventDefault();Navto(-1)  } } className=" h-[3.5rem]  text-[1.1rem]    border-solid border-[1px] text-gray-400   font-medium   w-full  rounded-[0.32rem] ">
             {t('card.Cancel')}
          </button>
          <button
          disabled={isLoading}
            type="submit"
            className=" h-[3.5rem] relative  text-[1.1rem] font-medium text-white w-full bg-main rounded-[0.32rem] "
          >
              {t('card.Submit')}
            <LoadingBtn  isLoading={isLoading} bg={'bg-main'} />
          </button>
        </div>
      </form>
      <Masseege msg={msg} setMsg={setMsg} />
    </div>
  );
}

export default AddCardManully;
